__turbopack_context__.v({
  "autoplay": "S2lB_a_autoplay",
  "overlay": "S2lB_a_overlay",
  "pause": "S2lB_a_pause",
  "play": "S2lB_a_play",
  "playing": "S2lB_a_playing",
});
